<template>
    <v-dialog v-model="dialogComentariosGuardados" persistent max-width="800">
        <v-card>
          <v-card-title>
            Comentarios
          </v-card-title>
          <v-card-text>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="comentarios"
              sort-by="publico"
              :search="buscar"
              item-key="texto"
              show-select
              dense
              :loading="loading"
              class="elevation-1"
              :items-per-page="5"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-text-field
                    v-model="buscar"
                    append-icon="mdi-file-search-outline"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-toolbar>
              </template>
              <template v-slot:item.publico="{ item }">
                <v-chip outlined small :color="item.publico ? 'default': authUser.color">
                  {{ item.publico ? 'Público' : authUser.name }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="$emit('close'), resetDialog()" color="error">Cerrar</v-btn>
            <v-btn text @click="$emit('aceptar', selected), resetDialog()">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { getComentarios } from '@/api/comentarios';

export default {
  name: "comentariosGuardados",
  mixins: [],
  props: [ 'dialogComentariosGuardados' ],
  components: {

  },
  data() {
    return {
      headers: [
        {
          text: "Comentarios",
          align: 'start',
          filterable: true,
          sortable: true,
          value: "texto",
        },
        {
          text: "Grupo",
          align: 'start',
          filterable: true,
          sortable: true,
          value: "publico",
        },
      ],
      comentarios: [],
      selected: [],
      buscar: '',
      loading: false
    }
  },
  methods: {
    resetDialog(){
      this.selected = []
      this.buscar = ''
    }
  },
  computed: {
    ...mapState("login", ["authUser"]),
    getChip(valor){
      return {
        text: 'Público',
        color: 'info'
      }
    }
  },
  watch: {
    dialogComentariosGuardados(){
      if(this.dialogComentariosGuardados && this.comentarios.length === 0){
        this.loading = true
        getComentarios().then(respuesta => {
          console.log(respuesta.data)
          this.comentarios = respuesta.data
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
};
</script>

<style scoped>

</style>